import React, { Component } from 'react';
import { chooseAction } from '../actions/chooseAction';
import { executeAction } from '../actions/execute.action';
import { LoadingResponseComponent } from "./message-components/loading-response.component";
import GlobalStoreService from "../services/global-store.service";
import UtilService from "../services/util.service";
import DBReadWriteService from "../services/db-read-write.service";
import CommonOptionsResponseComponent from "./scenario-options-components/options-response.component";
import GLOBAL_CONFIG from '../config/config';
import { globalConstants } from "../constants/globalConstants";
import { SCRIPTS } from "../constants/staticScripts";
import ChatActionType from "../enums/action-types/ChatActionType";
import retryMessageComponent from "./message-components/retry_message.component";
import BotType from '../enums/BotType';
import PopUp from './common-components/popup'
import ConfirmationBox from './common-components/confirmation-box.component'
import IdleTimeoutService from "../services/idle-timeout.service";
import componentService from '../services/chooseComponentToRender.service'
import InitializeChatBotService from '../services/initialize-chatbot-data.service'
import { calculateOptionsPosition, calculateOptionsLeftPosition } from '../services/UICalculations.service'
import bottomComponent from './bottom-component'
import TrackingMiddlewareService from '../services/tracking-middleware.service'
import { handleReadReturnFromDB } from '../services/handle-chat-history-from-db.service'
import LoginService from '../services/handle-user-login.service'
import ComponentTypes from '../enums/ComponentTypes'
import TrackingKey from '../enums/trackingKey'
import UserActionClass from '../objectClasses/user-action-class'
import UserActionType from '../enums/UserActionType'
import UserAction from '../services/handle-user-action.service'
import TrackingPlatform from '../enums/TrackingPlatform'


class ChatMessage extends Component {


    constructor(props) {
        super(props);

        this.state = {
            responseAwaiting: false,
            disableOptionClicks: false,
            current_scenario: undefined,
            response_options: undefined,
            fieldType: globalConstants.INPUT_FIELD_TYPES.CHAT,
            show_retry: false,
            show_popup: false,
            messages_arr: [],
            popupVisible: true,
            disableInputField: false,
            chatHistoryMessages: [],
            readOnScroll: false,
            bottom_comp: { type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR },
            showHistoryMessages: false,
            readFromDBReturned: true,
            redirectCase: false,
            showNumbersToSwitchBot: false,
            userActionObject: null
        }
        this.retry_count = 0
        this.allMessagesRef = React.createRef();
        this.historyMessagesRef = React.createRef();
        this.currentMessagesRef = React.createRef();
        this.chatOptionsRef = React.createRef();
        this.loginDetails = {
            isUserLoggedIn: false,
            loggedInMsisdn: ""
        }
    }

    componentDidMount() {
        this.setLoaderOn();
        // console.log('chat bot')
        InitializeChatBotService.getBasicTokenAndInitializeChatBotData().then((response) => {
            if (GlobalStoreService.get("APP_CONTEXT")) {
                LoginService.loginInApp().then(() => {
                    LoginService.afterInitialLoginSuccess({ message_comp: this });
                }).catch((err) => {
                    this.setLoaderOff();
                    this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
                })
            }
            if (!GlobalStoreService.get("APP_CONTEXT")) {
                window.addEventListener("message", this.receiveMessage.bind(this), false);
                window.parent.postMessage("INITIATED", GLOBAL_CONFIG.parentOrigin);
            }
        }, (error) => {
            TrackingMiddlewareService.trackEvent(TrackingKey.ERROR_BACKEND)
            this.setLoaderOff();
            this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })

        })

        this.synth = window.speechSynthesis;
        if (this.synth) {
            this.synth.getVoices().map(voice => {
                // console.log(voice)
                if (voice.voiceURI === "Veena") {
                    this.voice_chosen = voice
                    return
                }
            })
        }
    }

    readReturnMethod = (data) => {

        handleReadReturnFromDB({ data, message_comp: this, readOnScroll: this.state.readOnScroll })
        if (this.state.readOnScroll) {
            setTimeout(() => {
                this.setState({ readFromDBReturned: true })
            }, 300)
        }
    }

    addNewMessages = ({ new_messages, pop_count }) => {
        //new_messages is an array of messages
        let messages_arr = this.state.messages_arr
        if (pop_count !== undefined) {
            messages_arr.pop();
        }

        DBReadWriteService.writeMessagesToDBQueue(new_messages)

        this.setState({ messages_arr: [...this.state.messages_arr, ...new_messages] })
        setTimeout(() => {
            UtilService.handleDtLink(this.handleDtLink.bind(this));
        }, 300);
        this.scrollToBottom()

    }

    afterLoginAtALaterStage = () => {
        LoginService.afterLoginAtALaterStage({ message_comp: this })
    }

    handleBottomBarCompState = (value) => {

        if (this.state.bottom_bar_comp !== value) {
            this.setState({ bottom_bar_comp: value })
        }
    }

    clearRetry = () => {
        // console.log('clear retry')
        this.retry_count = 0
        this.setState({ show_retry: false })
    }

    hideFeedbackOptions = () => {
        this.setState({ showFeedbackOptions: false })
    }

    showFeedbackOptions = () => {
        this.setState({ showFeedbackOptions: true })
    }

    setResponseOptions = (new_options) => {
        this.setState({ response_options: new_options })
    }

    clearResponseOptions = () => {
        this.setState({ response_options: undefined })
    }

    setCurrentScenario = (scenario) => {
        this.setState({ current_scenario: scenario })
    }

    disableBottomBar = () => {
        this.setState({ disableBottomBar: true })
    }

    enableBottomBar = () => {
        this.setState({ disableBottomBar: false })
    }

    showNumbersToSwitchBot = () => {
        this.setState({ showNumbersToSwitchBot: true })
    }

    disableNumbersToSwitchBot = () => {
        UtilService.disableSwitchMessageButtonClick()
        this.setState({ showNumbersToSwitchBot: false })
    }

    setLoaderOn = () => {
        this.setState({
            responseAwaiting: true,
        });
        this.hideFeedbackOptions()
        this.scrollToBottom();
    }

    setLoaderOff = () => {
        this.setState({
            responseAwaiting: false,
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        IdleTimeoutService.updateIdleState();

        if (prevState.current_scenario !== this.state.current_scenario) {
            //NEW TRACKING - UPDATE CURRENT SCENARIO IN TRACKING
            TrackingMiddlewareService.setTrackingData({ current_scenario: this.state.current_scenario })

            const currentMessagesDiv = this.currentMessagesRef.current
            if (currentMessagesDiv.scrollHeight > currentMessagesDiv.clientHeight) {
                currentMessagesDiv.style.height = "auto"
            }

        }

        // if (prevState.messages_arr.length !== this.state.messages_arr.length || this.state.responseAwaiting) {
        //     // this.scrollToBottom();
        //     this.messagesEnd && this.messagesEnd.scrollIntoView({ behavior: "instant", block: "end" });
        // }

        if (document.getElementById('welcome_multiple_div') && document.getElementById('welcome_multiple_image')) {
            let diff = document.getElementById('welcome_multiple_image').clientHeight > document.getElementById('welcome_multiple_div').clientHeight ? document.getElementById('welcome_multiple_div').clientHeight - document.getElementById('welcome_multiple_image').clientHeight : 0

            document.getElementById('welcome_multiple_image').style.bottom = `${diff}px`
        }
        //popup visible or not handled
        if (snapshot && snapshot.hasOwnProperty('popupVisible') && snapshot.popupVisible !== this.state.popupVisible) {
            this.setState({ popupVisible: snapshot.popupVisible })
        }
        // ------ calculate position for options (fixed to bottom or scrollable with messages)
        calculateOptionsPosition();
        if (this.state.response_options) {
            calculateOptionsLeftPosition();
        }

        if (snapshot && snapshot.showHistoryMessages) {
            const currentMessagesDiv = this.currentMessagesRef.current
            const chatOptionsDiv = this.chatOptionsRef.current
            let currentDivHeight = currentMessagesDiv.scrollHeight
            if (!this.state.redirectCase && snapshot.showHistoryMessages && currentMessagesDiv.scrollHeight + chatOptionsDiv.scrollHeight < snapshot.showHistoryMessages) {
                currentMessagesDiv.style.height = (snapshot.showHistoryMessages - 81) + "px"
                currentDivHeight = (snapshot.showHistoryMessages - chatOptionsDiv.scrollHeight)
            }

            const allMessagesDiv = this.allMessagesRef.current;
            let currentHeight = allMessagesDiv.scrollHeight;
            // console.log('current height',currentHeight)
            document.getElementById('chat_message_id').scrollTop = currentHeight - currentDivHeight
        }

        //set the scroll position on reading history messages
        if (snapshot && snapshot.readOnScroll) {

            const allMessagesDiv = this.allMessagesRef.current;
            let currentHeight = allMessagesDiv.scrollHeight;
            // console.log('current height',currentHeight)
            document.getElementById('chat_message_id').scrollTop = currentHeight - snapshot.readOnScroll
        }

        UtilService.checkForCarouselWebScrollArrows();
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {

        let popupVisible = this.state.popupVisible
        if (prevProps.showCloseChatConfirmationPopup) {
            let feedbackSkippedTracking = UserAction.checkForFeedbackSkippedTracking(null, this.state.current_scenario)
            if (feedbackSkippedTracking || true) {
                this.props.setFeedbackRequired(true, feedbackSkippedTracking)
            }
        }
        if (prevState.popupVisible !== this.state.popupVisible) {
            popupVisible = this.state.popupVisible
        }
        else if (prevProps.hideMessagePopup !== this.props.hideMessagePopup && this.props.hideMessagePopup) {
            popupVisible = false
        }
        else if (prevProps.hideMessagePopup !== this.props.hideMessagePopup && !this.props.hideMessagePopup) {
            popupVisible = true
        }
        if (prevProps.isMaximized !== this.props.isMaximized && this.props.isMaximized && !this.props.hideMessagePopup) {
            popupVisible = true
        }
        else if (prevProps.isMaximized !== this.props.isMaximized && !this.props.isMaximized || this.props.hideMessagePopup) {
            popupVisible = false
        }
        if (this.state.showHistoryMessages !== prevState.showHistoryMessages) {
            const allMessagesDiv = this.allMessagesRef.current;
            return { 'showHistoryMessages': allMessagesDiv.scrollHeight, popupVisible }
        }
        if (this.state.response_options !== prevState.response_options) {
            const chatOptionsDiv = this.chatOptionsRef.current
            return { 'responseOptions': chatOptionsDiv.scrollHeight, popupVisible }
        }

        if (prevState.chatHistoryMessages.length < this.state.chatHistoryMessages.length) {
            const allMessagesDiv = this.allMessagesRef.current;
            return { 'readOnScroll': allMessagesDiv.scrollHeight, popupVisible }
        }
        return { popupVisible };
    }

    showHistoryMessages = () => {

        if (this.state.chatHistoryMessages && this.state.chatHistoryMessages.length > 0) {
            this.setState({ readFromDBReturned: false })
            setTimeout(() => {
                this.setState({ showHistoryMessages: true, readFromDBReturned: true })
            }, 1000)
        }

    }

    onSkipClick = ({ pop_count }) => {
        this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.SKIP_MESSAGE)], pop_count })
        this.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })
        if (this.state.current_scenario.initiate_after_login) {
            this.setState({ current_scenario: { ...this.state.current_scenario, initiate_after_login: false } })
        }
    }

    setBottomBarComponentState = (bottom_comp_obj) => {
        this.setState({ bottom_comp: bottom_comp_obj })
    }

    closeLoginComp = ({ skip }) => {
        if (skip) {
            this.onSkipClick({})
        }
        this.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })
        // this.setState({ current_scenario: { ...this.state.current_scenario, initiate_after_login: false } })
        this.setState({ current_scenario: { ...this.state.current_scenario } })
    }



    handleDtLink = (data) => {
        this.setLoaderOn();
        // console.log('handle dt link', data)

        let userAction = new UserActionClass(UserActionType.DT_LINK_CLICK, null, null, null, null, null, data.scenarioResponse)
        this.setState({ userActionObject: userAction })
        IdleTimeoutService.updateIdleState();
        const selectedAction = chooseAction({
            data: data,
            scenarioResponse: data.scenarioResponse
        });
        const result = executeAction(selectedAction, {
            scenarioResponse: data.scenarioResponse,
        }, this.retry_count)
        result.then((response) => {
            // console.log(response)
            if (response.hasOwnProperty('show_cancel_comp') && response.show_cancel_comp) {
                GlobalStoreService.set("components_handler", { ...GlobalStoreService.get('components_handler'), bottom_bar_comp: 'cancel-comp' });
                this.setState({ bottom_bar_comp: 'cancel-comp', cancel_obj: response.cancel_obj })
            }
            if (response.bottom_comp) {
                this.setBottomBarComponentState(response.bottom_comp)
                if (response.bottom_comp && response.bottom_comp.type === globalConstants.BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT) {
                    this.setState({ initiateScenarioAfterLoginParams: { scenarioResponse: data.scenarioResponse } })
                }
            }
            if (response && response.initiateRetry) {
                this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
            }
            if (response.message_objects) {
                this.addNewMessages({ new_messages: response.message_objects })
            }
            //TRACK SCENARIO QUERY FOR EXECUTE DT LINK
            if (response.scenarioResponse) {
                TrackingMiddlewareService.setTrackingData({ scenarioName: response.scenarioResponse.scenario.scenarioName || "", scenarioStrategy: "DTScenario" })
            }
            // TrackingMiddlewareService.trackEvent(TrackingKey.SCENARIO_QUERY)

            this.setLoaderOff();
            this.setCurrentScenario(response.scenarioResponse);
            this.setResponseOptions(response.chatItem);
        }, (error) => {
            // console.log(error);
            this.handleErrorAfterExecution(error, selectedAction)
        });
    }

    disableOptionClicks = (value) => {
        this.setState({ disableOptionClicks: value })
    }

    endCurrentScenario = () => {
        this.setState({ current_scenario: { ...this.state.current_scenario, scenarioActive: false, templateNameList: [] }, fieldType: globalConstants.INPUT_FIELD_TYPES.CHAT })
        this.setBottomBarToInput()
    }

    handleUserAction = (userActionObject) => {

        // if (this.state.showNumbersToSwitchBot) {
        this.disableNumbersToSwitchBot()
        // }
        if (userActionObject && userActionObject.actionType !== UserActionType.RETRY_CLICK) {
            this.setState({ userActionObject })
        }
        if (userActionObject) {
            UserAction.handleUserAction(userActionObject, this)
        }
        else {
            this.endCurrentScenario();
        }
    }

    showPopup = (popup_comp, popup_height, popup_width) => {
        if (popup_comp)
            this.setState({ show_popup: true, popup_data: popup_comp, popup_height, popup_width })
        else
            this.setState({ show_popup: false, popup_data: undefined })
    }

    responseHasDefaultMessage = (response) => {

        if (response && response.message_objects && response.message_objects.length > 0) {
            for (let i = 0; i < response.message_objects.length; i++) {
                let message_obj = response.message_objects[i]
                if (message_obj.component_type === ComponentTypes.DEFAULT) {
                    return UtilService.getSpeechResponse(message_obj.message)
                }
            }
        }
        else {
            return false
        }
    }

    handleSpeechSynthesis = (response) => {

        let speech_message = this.responseHasDefaultMessage(response)

        if (speech_message) {
            // var synth = window.speechSynthesis;
            // let voice_chosen
            if (this.synth) {
                // console.log(synth)
                if ((this.voice_chosen && this.voice_chosen.voiceURI !== 'Veena') || !this.voice_chosen) {
                    this.synth.getVoices().map(voice => {
                        // console.log(voice)
                        if (voice.voiceURI === "Veena") {
                            this.voice_chosen = voice
                            return
                        }
                    })
                }
                if (this.synth.speaking) {
                    return;
                }
                var utterThis = new SpeechSynthesisUtterance(speech_message);
                if (utterThis) {
                    utterThis.voice = this.voice_chosen
                }
                utterThis.onend = function (event) {
                }
                utterThis.onerror = function (event) {
                }
            }
        }
    }


    handleResponseAfterExecution = ({ response, user_response, user_res, scenarioResponse, aditionalData, actionType, end_scenario }) => {


        //    response && this.handleSpeechSynthesis(response);

        if (response && response.hasOwnProperty('INITIATE_AFTER_LOGIN_IN_MULTIPLE')) {
            this.setState({ initiate_after_login_in_multiple: response['INITIATE_AFTER_LOGIN_IN_MULTIPLE'] })
            this.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU })
            this.setLoaderOff();
            this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.SELECT_ACCOUNT)] })
        }

        else if (response && response.initiateRetry) {

            this.setState({ show_retry: true })

            this.scrollToBottom();
            //CHECK-- in case retry shown after country select step the field type should change to default to chat
            if (response && response.scenarioResponse && response.scenarioResponse.templateNameList && UtilService.isCountryTemplate(response.scenarioResponse.templateNameList)) {
                this.setState({
                    fieldType: globalConstants.INPUT_FIELD_TYPES.PLACE,
                });
            } else {
                this.setState({
                    fieldType: globalConstants.INPUT_FIELD_TYPES.CHAT,
                });
            }
        }
        else {
            if (response.bottom_comp) {
                this.setBottomBarComponentState(response.bottom_comp)
                if (response.bottom_comp && response.bottom_comp.type === globalConstants.BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT) {
                    this.setState({ initiateScenarioAfterLoginParams: { user_response, user_res, scenarioResponse, aditionalData, actionType } })
                }
            }
            else {
                this.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })
            }
            if (!response) {
                this.setLoaderOff();
                this.disableOptionClicks(false);

                const current_scenario = { ...this.state.current_scenario };
                current_scenario.scenarioActive = false;
                this.setState({
                    current_scenario
                })
                return;
            }
            if (response.message_objects) {
                this.addNewMessages({ new_messages: response.message_objects })
            }
            if (response && response.scenarioResponse && response.scenarioResponse.templateNameList && UtilService.isCountryTemplate(response.scenarioResponse.templateNameList)) {
                this.setState({
                    fieldType: globalConstants.INPUT_FIELD_TYPES.PLACE,
                });
            } else {
                this.setState({
                    fieldType: globalConstants.INPUT_FIELD_TYPES.CHAT,
                });
            }
            if (response && response.scenarioResponse && response.scenarioResponse.templateNameList && UtilService.hasTemplateDisableInput(response.scenarioResponse.templateNameList)) {
                this.setState({ disableInputField: true })
            }
            else {
                this.setState({ disableInputField: false })
            }

            if (response && response.scenarioResponse && response.scenarioResponse.scenario &&
                response.scenarioResponse.scenario.feedbackRequired && !response.scenarioResponse.scenarioActive
                && !response.scenarioResponse.initiate_after_login &&
                (!response.bottom_comp || (response.bottom_comp && response.bottom_comp.type !== globalConstants.BOTTOM_BAR_COMPONENTS.DFF_FORM_COMPONENT))) {
                this.showFeedbackOptions();
            }
            else {
                this.hideFeedbackOptions();
            }
            this.setCurrentScenario(response.scenarioResponse)
            this.setResponseOptions(response.chatItem)
        }
        this.scrollToBottom()
        this.setLoaderOff();
        this.disableOptionClicks(false)
    }


    handleErrorAfterExecution = (error, selectedAction) => {
        console.log(error)
        if (error && error.message_objects) {
            this.addNewMessages({ new_messages: error.message_objects })
        }
        else {
            this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
        }
        this.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })
        this.setLoaderOff();
        this.disableOptionClicks(false);
        if (selectedAction !== ChatActionType.NO_ACTION_CHOSEN) {
            let scenarioName = (this.state && this.state.current_scenario && this.state.current_scenario.scenario && this.state.current_scenario.scenario.scenarioName) ? this.state.current_scenario.scenario.scenarioName : ""
            //TRACK ERROR BACKEND
            TrackingMiddlewareService.trackEvent(TrackingKey.ERROR_BACKEND)
        }
    }

    initiateScenarioAfterLogin = () => {

        if (this.state.userActionObject) {
            if (this.state.userActionObject.actionType === UserActionType.DT_LINK_CLICK && this.state.userActionObject.dtLinkScenario) {
                this.setLoaderOn();
                UserAction.sendApiRequest({ actionType: "INITIATE", scenarioResponse: { ...this.state.userActionObject.dtLinkScenario } }, this)
            }
            else {
                let query = UserAction.getChatBotQuery(this.state.userActionObject)
                if (query) {
                    this.setLoaderOn();
                    UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.DEFAULT, user_response: query, user_res: query }, this, query)
                }
                else {
                    this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
                }
            }
        }
    }




    onSwitchNumber = (account) => {

        let prevBotType = GlobalStoreService.get("currentBotType")

        GlobalStoreService.set("currentNumber", account.siNumber);
        GlobalStoreService.set("currentBotType", account.type);

        if (account && account.type != prevBotType) {
            if (account.type === BotType.POSTPAID) {
                //TRACK SWITCH PRE TO POST
                TrackingMiddlewareService.trackEvent(TrackingKey.SWITCH_CLICK_PRE_TO_POST)
            } else {
                //TRACK SWITCH POST TO PRE
                TrackingMiddlewareService.trackEvent(TrackingKey.SWITCH_CLICK_POST_TO_PRE)
            }
        }
        IdleTimeoutService.updateIdleState();

        //since number switched selected current scenario needs to exit and new chat out call to execute in next response
        this.endCurrentScenario();
        this.clearResponseOptions();
        this.clearRetry();
        this.hideFeedbackOptions();
        this.setState({ disableInputField: false })
        let new_messages = []
        new_messages.push(UtilService.createUserMessageObject(`${account.siNumber}`))
        new_messages.push(UtilService.createChatBotMessageObject(globalConstants.successful_switch_message + account.siNumber))

        this.addNewMessages({ new_messages })
        this.addNewMessages({ new_messages })

        if (this.state.showNumbersToSwitchBot && this.state.userActionObject) {
            this.disableNumbersToSwitchBot()
            // console.log('user action before login form', this.state.userActionObject)
            let query = UserAction.getChatBotQuery(this.state.userActionObject)
            // console.log('query for bot', query)
            if (query) {
                this.setLoaderOn();
                // console.log('send query request')
                UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.DEFAULT, user_response: query, user_res: query }, this, query)
            }
            // this.handleUserAction({ ...this.state.userActionObject, afterBotSwitch: true })
        }
    }

    hideLogo = (messages_array, currentMessage, currentIndex) => {
        if (messages_array && messages_array[currentIndex - 1] && currentMessage.component_type === ComponentTypes.DEFAULT && messages_array[currentIndex - 1].component_type === ComponentTypes.DEFAULT) {
            return true
        }
        else {
            return false
        }
    }


    renderCurrentMessages = () => {

        const messageComponents = [...this.state.messages_arr].map((message, key) => {
            let hide_logo = this.hideLogo(this.state.messages_arr, message, key)
            let firstTimeMultiple = false
            if (message.component_type === 'WELCOME_COMPONENT_MULTIPLE' && key === this.state.messages_arr.length - 1) {
                firstTimeMultiple = true
            }
            let component = componentService.chooseComponentToRender({ message, handleUserAction: this.handleUserAction, showPopup: this.showPopup, hide_logo, firstTimeMultiple, setBottomBarToInput: this.setBottomBarToInput, showNumbersToSwitchBot: this.showNumbersToSwitchBot })

            return (
                <div className="chat-left-block" key={key}>
                    {component}
                </div>
            )
        })

        return messageComponents;
    }

    renderHistoryMessages = () => {

        const messageComponents = [...this.state.chatHistoryMessages].map((message, key) => {
            let hide_logo = this.hideLogo(this.state.chatHistoryMessages, message, key)
            let component = componentService.chooseComponentToRender({ message, handleUserAction: this.handleUserAction, showPopup: this.showPopup, hide_logo, firstTimeMultiple: false, showNumbersToSwitchBot: this.showNumbersToSwitchBot })

            return (
                <div className="chat-left-block" key={key}>
                    {component}
                </div>
            )
        })
        return messageComponents;
    }

    initiateWelcomeScenario = () => {

        const selectedAction = chooseAction({ data: this.loginDetails });
        const resultantComponentPromise = executeAction(selectedAction, GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]['WELCOME'], this.retry_count);
        resultantComponentPromise.then(
            (response) => {
                this.setLoaderOff();
                if (response && response.initiateRetry) {
                    this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
                }
                else {
                    if (response.message_objects) {
                        this.addNewMessages({ new_messages: response.message_objects })
                    }

                    this.setResponseOptions(response.chatItem)
                    this.setCurrentScenario(response.scenarioResponse)
                }
                // TRACK CHAT LAUNCH SUCCESS
                TrackingMiddlewareService.trackEvent(TrackingKey.START_CHAT_SUCCESS)
            }, (error) => {
                // TRACK CHAT LAUNCH FAIL
                TrackingMiddlewareService.trackEvent(TrackingKey.START_CHAT_FAIL)
                this.handleErrorAfterExecution(error, selectedAction);
            });
    }

    initiateWelcomeScenarioForCurrentBot = () => {
        this.setLoaderOn()
        // console.log('initiate welcome scenario')
        const selectedAction = chooseAction({ data: this.loginDetails });
        const resultantComponentPromise = executeAction(selectedAction, GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]['WELCOME'], this.retry_count);
        resultantComponentPromise.then(
            (response) => {
                this.setLoaderOff();
                if (response && response.initiateRetry) {
                    this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
                }
                else {
                    if (response.message_objects) {
                        this.addNewMessages({ new_messages: response.message_objects })
                    }

                    this.setResponseOptions(response.chatItem)
                    this.setCurrentScenario(response.scenarioResponse)
                }
            }, (error) => {
                this.handleErrorAfterExecution(error, selectedAction);
            });
    }

    receiveMessage(event) {
        if (event.data && typeof event.data === "string") {
            try {
                if (GlobalStoreService.get("APP_CONTEXT")) {
                    // LoginInAppService.handleLoginInApp({ message_comp: this });
                }
                else if (event && event.data && event.data.indexOf("loginDetails") != -1) {

                    const dataReceivedFromAirtelUI = JSON.parse(event.data);
                    this.loginDetails = dataReceivedFromAirtelUI.loginDetails;
                    if (this.loginDetails.isUserLoggedIn) {
                        let mobNo = this.loginDetails.loggedInMsisdn
                        LoginService.loginInWeb(mobNo).then(() => {
                            LoginService.afterInitialLoginSuccess({ message_comp: this });
                        }).catch((err) => {
                            this.setLoaderOff();
                            this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
                        })
                    } else {
                        //CHECK 
                        this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME)] })
                        this.initiateWelcomeScenario();
                    }

                }
            } catch (exception) {
                // console.log('receive message exception',exception);
                this.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
                // TRACK CHAT LAUNCH FAIL
                TrackingMiddlewareService.trackEvent(TrackingKey.START_CHAT_FAIL)

                TrackingMiddlewareService.trackEvent(TrackingKey.ERROR_FRONTEND)
            }
        }
        return true;
    }

    onNumberSelected = ({ user_response, show_number }) => {
        this.setState({ response_options: undefined })
        this.setLoaderOn();
        let new_messages = []
        if (show_number) {
            new_messages.push({
                component_type: 'USER_RESPONSE',
                message: user_response ? user_response : GlobalStoreService.get("currentNumber"),
                messageTime: UtilService.getCurrentTime(),
            })
            new_messages.push({
                component_type: 'DEFAULT',
                message: globalConstants.number_selected_acknowledgement_msg,
                messageTime: UtilService.getCurrentTime(),
            })
        }
        this.showHistoryMessages();
        this.addNewMessages({ new_messages })
        this.initiateWelcomeScenario();
    }

    scrollToBottom = () => {
        const scrolltimer = setTimeout(() => {
            this.messagesEnd && this.messagesEnd.scrollIntoView({ behavior: "instant", block: "end" });
            clearTimeout(scrolltimer);
        }, 100);
    }

    setBottomBarToInput = () => {
        this.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })
    }

    handleCancelButtonClick = () => {
        IdleTimeoutService.updateIdleState();
        this.showPopup(
            <ConfirmationBox
                title={(this.state.bottom_comp.cancel_obj.type) ? globalConstants.CANCEL_CASES[this.state.bottom_comp.cancel_obj.type].title : 'Cancel current chat?'}
                messages={[(this.state.bottom_comp.cancel_obj.type) ? globalConstants.CANCEL_CASES[this.state.bottom_comp.cancel_obj.type].message : 'This will end your current chat']}
                buttons={[
                    {
                        label: 'NO',
                        onClick: () => {
                            this.showPopup(undefined)
                        }
                    },
                    {
                        highlight: true,
                        label: 'YES',
                        onClick: () => {

                            this.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR })

                            this.showPopup(undefined)
                            if (this.state.bottom_comp.cancel_obj) {
                                let chatItem = this.state.bottom_comp.cancel_obj.chatItem
                                chatItem.scenarioResponse.templateNameList = []

                                this.handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED, 'CANCEL', null, null, globalConstants.CANCEL_CASES[this.state.bottom_comp.cancel_obj.type].cancel_user_response))
                                switch (this.state.bottom_comp.cancel_obj.type) {
                                    case 'IR_PACK': {
                                        UtilService.disableActivateIrCardLink()
                                    }
                                    case 'IR_ACTIVATED_PACKS_DEACTIVATION': {
                                        UtilService.disableDeactivateIrCardLink()
                                    }
                                    default: { }
                                }
                            }
                        }
                    },
                ]} />)
    }

    setReadOnScroll = () => {
        this.setState({ readOnScroll: true, readFromDBReturned: false })
    }

    getChatHistoryOnScroll = (event) => {
        // console.log('on scroll')
        if ((GlobalStoreService.get("APP_CONTEXT"))) {
            let scrolltop = event.target.scrollTop;
            let scrollHeight = event.target.scrollHeight
            if (event.target.scrollHeight > event.target.clientHeight && scrolltop < 20 && DBReadWriteService.db_read_offset !== -1 && DBReadWriteService.db_read_offset > 0) {
                //READ CHAT HISTORY
                this.setReadOnScroll();
                DBReadWriteService.readFromDB();
            }
        }
    }


    render() {
        const isApp = (GlobalStoreService.get("APP_CONTEXT")) ? true : false;
        let ios_class = UtilService.getIosSpecificClass()
        return (
            <div id="main-inner" style={{
                display: 'grid',
                gridTemplateRows: '1fr max-content',
                height: isApp ? '100%' : 'calc(100% - 56px)',
                marginTop: (isApp) ? 0 : '56px',
                overflow: 'hidden'
            }}>
                <div id="chat_message_id"
                    ref={this.allMessagesRef}
                    className={"chatMessage home mt-0 " + " " + (UtilService.getOS() === "Windows" ? "custom-scrollbar" : "") + " " + ios_class}
                    style={{ display: 'block', overflowY: 'scroll', position: 'relative' }}
                    onScroll={(event) => { this.getChatHistoryOnScroll(event) }}>
                    {/* CHAT MESSAGE LIST */}
                    <div id="chat_list_id" className={"pb-10" + " " + ios_class} style={{ width: '100%' }}>
                        {!this.state.readFromDBReturned &&
                            <div style={{ textAlign: 'center' }}>
                                <img src={`${process.env.PUBLIC_URL}/assets/images/messagesLoader.gif`} width="25px" />
                            </div>
                        }
                        <div id="historyMessagesDiv" className={"overflow-scroll" + " " + ios_class}
                            ref={this.historyMessagesRef}>
                            {this.state.showHistoryMessages && this.renderHistoryMessages()}
                        </div>
                        <div id="currentMessagesDiv" className={"overflow-scroll" + " " + ios_class}
                            ref={this.currentMessagesRef}>
                            {this.renderCurrentMessages()}
                            {this.state.responseAwaiting && <LoadingResponseComponent messages={this.state.messages_arr} />}
                        </div>
                        {this.state.show_retry && retryMessageComponent(this.handleRetry)}
                    </div>
                    <div id="chat_options_id" ref={this.chatOptionsRef}>
                        {(this.state.response_options || this.state.showFeedbackOptions || this.state.show_retry) &&
                            CommonOptionsResponseComponent({
                                chatItem: this.state.response_options,
                                handleUserAction: this.handleUserAction,
                                showFeedbackOptions: this.state.showFeedbackOptions,
                                show_retry: this.state.show_retry,
                                showPopup: this.showPopup,
                            })}</div>
                    <div style={{ float: "left", clear: "both" }} id="messagesEnd"
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
                <div style={{ pointerEvents: (this.state.responseAwaiting || this.state.disableBottomBar) ? 'none' : 'auto' }}>
                    {bottomComponent({ messageComp: this })}
                </div>
                {this.state.show_popup && this.state.popup_data && PopUp(this.state.popup_data, this.state.popupVisible, this.state.popup_height, this.state.popup_width)}

            </div>
        );
    }
}

export default ChatMessage;


// WEBPACK FOOTER //
// ./src/components/chatMessageComponent.js